import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import className from "classnames";
import dayjs from "dayjs";
import { isEmpty } from "lodash";
import ErrorMessage from "components/ErrorMessage";
import helpers from "utils/helpers";

const FormDateRangePicker = (props) => {
  const [isFirstRenderDone, setIsFirstRenderDone] = useState(0);
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [addFlex, setAddFlex] = useState(true);

  const [minTimeValue, setMinTimeValue] = useState("00:00");

  useEffect(() => {
    setIsFirstRenderDone(1);
    if (!isEmpty(props.selectStartDate)) {
      setStartDate(dayjs(props.selectStartDate).toDate());
    }
    if (!isEmpty(props.selectEndDate)) {
      setEndDate(dayjs(props.selectEndDate).toDate());
    }
  }, [props.selectStartDate, props.selectEndDate]);

  const onChangeStartDate = ([date]) => {
    setStartDate(date);
    props?.handleDateChange(date, endDate);
  };
  const onChangeEndDate = ([date]) => {
    setEndDate(date);
    props.handleDateChange(startDate, date);
  };
  const handleReset = () => {
    setStartDate("");
    setEndDate("");
  };
  useEffect(() => {
    if (isFirstRenderDone === 1) {
      handleReset();
      if (props?.isReset) {
        props?.setIsReset(false);
      }
    }
    if (props?.addFlex === false) {
      setAddFlex(props?.addFlex);
    }
  }, [props?.isReset]);

  useEffect(() => {
    const now = dayjs();
    if (now.format("YYYY-MM-DD") === dayjs(startDate).format("YYYY-MM-DD")) {
      setMinTimeValue(now.format("HH:mm"));
    } else {
      setMinTimeValue("00:00");
    }
  }, [startDate]);

  useEffect(() => {
    const now = dayjs();
    setMinTimeValue(now.format("HH:mm"));
  }, []);

  return (
    <div className="grid sm:grid-cols-2 grid-cols-1 gap-4">
      <div
        className={className("items-center mb-3 font-small", {
          // flex: addFlex,
        })}
      >
        {/* <label className="mx-2 text-[#000] text-xs">
          {helpers.ternaryCondition(
            props.selectDateFrom,
            <>
              <span className="text-gray-400">
                {t("SELECT_START_DATE_TIME")}
                <span className="text-red-500">*</span>
              </span>
            </>,
            t("O_FROM")
          )}
        </label> */}

        <div className="relative">
          <Flatpickr
            className="cursor-pointer bg-hero bg-[right_10px_top_10px] bg-[length:18px_18px] bg-no-repeat flex flex-row-reverse border-2 border-[#DFDFDF] text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            name="start_date"
            placeholder={t("SELECT_START_DATE")}
            value={startDate}
            options={{
              enableTime: true,
              maxDate: endDate,
              dateFormat: "m-d-Y | h:i K",
              defaultHour: startDate ? dayjs(startDate).hour() : dayjs().hour(),
              defaultMinute: startDate ? dayjs(startDate).minute() : dayjs().minute(),
              minTime: minTimeValue,
              time_24hr: false,
              minDate: props?.isEditForm || startDate ? null : "today", // ✅ allow DB values, else restrict
              showMonths: true,
            }}
            onChange={onChangeStartDate}
          />
          <ErrorMessage message={props.errors?.startDate} />
        </div>
      </div>
      <div
        className={className("items-center mb-3 font-small", {
          // flex: addFlex,
        })}
      >
        {/* <label className="mx-1 text-[#000] text-xs">
          {props.selectDateTo ? (
            <span className="text-gray-400">
              {t("SELECT_END_DATE_TIME")}
              <span className="text-red-500">*</span>
            </span>
          ) : (
            t("O_TO")
          )}
        </label> */}
        <div className="relative">
          <Flatpickr
            className="cursor-pointer bg-hero bg-[right_10px_top_10px] bg-[length:18px_18px] bg-no-repeat flex flex-row-reverse border-2 border-[#DFDFDF] text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            name="end_date"
            placeholder={t("SELECT_END_DATE")}
            value={endDate}
            options={{
              enableTime: true,
              minDate: startDate || "today",
              dateFormat: "m-d-Y | h:i K",
              defaultHour: endDate ? dayjs(endDate).hour() : dayjs().hour(),
              defaultMinute: endDate ? dayjs(endDate).minute() : dayjs().minute(),
              minTime: startDate ? dayjs(startDate).format("HH:mm") : "",
              time_24hr: false,
              showMonths: true,
            }}
            onChange={onChangeEndDate}
          />
          <ErrorMessage message={props.errors?.endDate} />
        </div>
      </div>
    </div>
  );
};

export default FormDateRangePicker;
